module.exports = __webpack_public_path__ + "static/media/3_col_3.4f5e9d32.jpg";